export class ReviewFormLabel_HN {

    review: {
        personal: string;
        income: string;
        loan: string;
    }

    thankyou:{
        caption1: string;
        caption2: string;
        caption3: string;
        caption4: string;
        caption5: string;
        caption6: string;
        caption7: string;
        caption8: string;
        caption9: string;
    }

    constructor() {

        this.review = {
            personal: "निजी",
            income: "आय",
            loan: "ऋण"
        }

        this.thankyou = {
            caption1: "रेनॉल्ट और रेनॉल्ट फाइनेंस को चुनने के लिए धन्यवाद।",
            caption2: "रेनॉल्ट फाइनेंस को आपके भरोसेमंद फाइनेंस पार्टनर के रूप में चुनने के आपके निर्णय को हम महत्व देते हैं।",
            caption3: "हम आपको यह बताना चाहते हैं कि हमारी ऑनलाइन वित्त यात्रा पूरी तरह से आपकी आसानी, आराम, सुरक्षा और अधिकांश के लिए बनाई गई है",
            caption4: "महत्वपूर्ण बात - आपकी खुशी!",
            caption5: "आपका ऋण आवेदन वर्तमान में संसाधित किया जा रहा है और हमारे कार्यकारी शीघ्र ही आपसे संपर्क करेंगे।",
            caption6: "ध्यान दें: कृपया इसे ऋण के लिए अनुमोदन न मानें।",
            caption7: "आपके समय और प्रयास के लिए हम एक बार फिर आपको धन्यवाद देते हैं।",
            caption8: "रेनॉल्ट दुनिया की खोज जारी रखने के लिए",
            caption9: "यहाँ क्लिक करें",
        }
    }
}